import React from "react";
import Dashboard from "./Dashboard";

const Dashboard2 = () => {
  return <Dashboard isDashboard2 />;
};

export default Dashboard2;
